import {initOrderSheetByStorage} from '@web/actions/orderSheetInfo'
import {MobilePrefix} from '@web/core/constants'
import makeSlice from '@web/slices/receiverInfo/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByStorage.fulfilled, (state, {payload}) => {
                const {data} = payload
                if (data.deliveryInfo.deliveryNothingOrder) {
                    state.receiverName = data.receiverInfo.receiverName
                    state.phoneNumber = data.receiverInfo.phoneNumber
                    state.usedAutofill = data.receiverInfo.usedAutofill
                }
            })
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {deliveryNothingOrder, purchaser, products} = payload.data

                const isBarcodeConnectedEcouponProductContained = products.some(
                    ({ecouponBarcodeConnect, ecoupon}) => ecouponBarcodeConnect && ecoupon,
                )
                // 배송없음 상품일때 수신자 이름
                if (deliveryNothingOrder) {
                    /**
                     * 휴대폰 번호 첫자리는 '010'으로 고정
                     * - 기존 번호가 010이 아니더라도 010으로 고정시키고,
                     * - 기존 번호와 달라서 결제가 안되는 경우 반드시 010으로 시작하는 번호로 수정해야함
                     * @ref https://wiki.fin.navercorp.com/pages/viewpage.action?pageId=85976856
                     */
                    const fixedPrefixPhoneNumber = purchaser.phoneNumber
                        ?.split('-')
                        .map((number, index) => {
                            return index === 0 ? MobilePrefix['010'] : number
                        })
                        .join('-')
                    state.receiverName = purchaser.name ?? ''
                    state.autofillPhoneNumber = fixedPrefixPhoneNumber ?? ''
                    state.usedAutofill = isBarcodeConnectedEcouponProductContained
                    state.isBarcodeConnectedEcouponProductContained = isBarcodeConnectedEcouponProductContained
                }
            })
    },
})

export default slice.reducer
